var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"voice_message"},[_vm._v("收不到短信，点击接收"),_c('span',{on:{"click":_vm.getSendVoiceCode}},[_vm._v("语音验证码")])])}
var staticRenderFns = []

export { render, staticRenderFns }